export function contact_sample() {
   const form_input_use = $('.c-form_input_use');
    const item  = $(".wpcf7-list-item-label");
    form_input_use.attr('disabled', 'disabled');
    item.on('click', function(){
        const parent = $(this).parents('.last');
        if (parent.length > 0 ) {
            form_input_use.attr('disabled', false);
        } else {
            form_input_use.attr('disabled', 'disabled');
        } 
    })
}